import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { notificationKeys } from '../queryKeys';
import { useMarkRead } from './useMarkRead';

/**
 * Marks a task's notifications read when its drawer opens (spec 131 FR-005),
 * once per task. Only when something is unread at all, so an inbox already
 * read does not cost a write on every drawer.
 */
export function useMarkTaskReadOnOpen(taskId: string): void {
  const queryClient = useQueryClient();
  const { mutate } = useMarkRead();
  useEffect(() => {
    const unread = queryClient.getQueryData<number>(notificationKeys.count());
    if (unread !== undefined && unread > 0) {
      mutate({ kind: 'task', taskId });
    }
  }, [taskId, queryClient, mutate]);
}
